import { type YDatabase } from '@databases/collab/y-database';
import { type FieldType } from '@databases/model/field';
import { err, ok, type Result } from 'neverthrow';

import { type SdkError } from '../../types';

/**
 * Ensures a field is of the expected type before a type-specific mutation
 * (e.g. select-option edits). Returns `STATE_ERROR('INVALID_FIELD_TYPE')` when
 * the field is missing or of a different type; otherwise `ok`.
 */
export function assertFieldIsType(
  ydb: YDatabase,
  fieldId: string,
  expectedType: FieldType
): Result<void, SdkError> {
  const field = ydb.fieldsById[fieldId];

  if (!field || field.type !== expectedType) {
    return err({
      type: 'STATE_ERROR',
      reason: 'INVALID_FIELD_TYPE',
      message: `Field '${fieldId}' is not of type '${expectedType}'`,
    });
  }

  return ok(undefined);
}
